import * as styledComponents from "styled-components";
import { ThemedStyledComponentsModule } from "styled-components";

import { CustomTheme } from "./theme";

const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  ThemeProvider,
} = styledComponents as ThemedStyledComponentsModule<CustomTheme>;

export { ThemeProvider, createGlobalStyle, css, keyframes };
export default styled;
